import { useSelector } from 'react-redux';

function useProviderConfig() {
  const { providerConfig } = useSelector((state) => state.providers);

  return { providers: providerConfig.providers || [], groups: providerConfig.groups || [] };
}

export default useProviderConfig;
